import { render, staticRenderFns } from "./featured-image.vue?vue&type=template&id=218366c9&scoped=true&lang=pug&"
import script from "./featured-image.vue?vue&type=script&lang=js&"
export * from "./featured-image.vue?vue&type=script&lang=js&"
import style0 from "./featured-image.vue?vue&type=style&index=0&id=218366c9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218366c9",
  null
  
)

export default component.exports